import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, unref as _unref, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-input__wrapper" }
const _hoisted_2 = { class: "p-input__input" }
const _hoisted_3 = ["disabled", "value", "placeholder", "type"]
const _hoisted_4 = { class: "p-popover__content" }
const _hoisted_5 = {
  key: 0,
  class: "p-input__label"
}
const _hoisted_6 = {
  key: 1,
  class: "p-input__info"
}

import { vMaska } from "maska/vue"
import {computed , ref} from 'vue';
import Popper from 'vue3-popper';
import EyeOpenedIcon from '@/common/icons/EyeOpenedIcon.vue';
import EyeClosedIcon from '@/common/icons/EyeClosedIcon.vue';

interface Props {
	valid?: boolean;
	validInfo?: string;
	value?: any;
	disabled?: boolean;
	label?: string;
	iconName?: string,
	outLabel?: boolean;
	isTooltip?: boolean;
	tooltipInfo?: string;
	tooltipProps?: object;
	placeholder?: string;
  mask?: string;
	type?: string
}

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'pInput',
  props: {
    valid: { type: Boolean, default: true },
    validInfo: {},
    value: {},
    disabled: { type: Boolean },
    label: {},
    iconName: {},
    outLabel: { type: Boolean, default: false },
    isTooltip: { type: Boolean },
    tooltipInfo: { default: '' },
    tooltipProps: {},
    placeholder: { default: '' },
    mask: { default: '' },
    type: {}
  },
  setup(__props: any) {

const props = __props;

// Refs
const focus = ref(false);
const passwordType = ref('password');

// Computed
const classes = computed(() => ({
	'p-input_default': true,
	'p-input_focus': focus.value || props.value,
	'p-input_out-label': props.outLabel,
	'p-input_error': !props.valid,
	'p-input_icon': props.iconName,
	'p-input_disabled': props.disabled,
	'p-input_success': props.valid && props.value !== null && props.value.length > 0 && typeof props.value !== 'undefined'
}));
const isLabel = computed(() => {
	return props.label?.length;
});
const cTooltipInfo = computed( () => {
	return props.tooltipInfo.length !== 0 ? props.tooltipInfo : props.validInfo;
});

// Methods
const onFocus = () => {
	focus.value = true;
};
const onBlur = () => {
	focus.value = false;
};

const togglePassword = () => {
  passwordType.value = passwordType.value === 'password' ? 'text' : 'password';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-input", classes.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.iconName?.length)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass(["p-icon", `p-icon-${_ctx.iconName}`])
            }, null, 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _withDirectives(_createElementVNode("input", _mergeProps(_ctx.$attrs, {
          disabled: _ctx.disabled,
          value: _ctx.value,
          placeholder: _ctx.placeholder,
          type: _ctx.type === 'password' ? passwordType.value : _ctx.type,
          onFocus: onFocus,
          onBlur: onBlur
        }), null, 16 /* FULL_PROPS */, _hoisted_3), [
          [_unref(vMaska), _ctx.mask]
        ]),
        (_ctx.type === 'password')
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(passwordType.value === 'text' ? EyeOpenedIcon : EyeClosedIcon), {
              key: 1,
              class: "password__eye",
              onClick: togglePassword
            }))
          : _createCommentVNode("v-if", true),
        _renderSlot(_ctx.$slots, "icon"),
        (_ctx.isTooltip)
          ? (_openBlock(), _createBlock(_unref(Popper), _mergeProps({ key: 2 }, _ctx.tooltipProps, { class: 'p-input__popover' }), {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(cTooltipInfo.value), 1 /* TEXT */)
              ]),
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(["p-icon p-icon-info", {'p-icon-error': !_ctx.valid && _ctx.tooltipInfo.length === 0}])
                }, null, 2 /* CLASS */)
              ]),
              _: 1 /* STABLE */
            }, 16 /* FULL_PROPS */))
          : _createCommentVNode("v-if", true)
      ]),
      (isLabel.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.label), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (!_ctx.valid && !_ctx.isTooltip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.validInfo), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}
}

})